<form nz-form nz-row [formGroup]="applySickLeaveForm" class="ppl-p0 mt-2">
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumer" class="ppl-form-label">
                Participant
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <nz-select formControlName="consumer" class="ppl-select" nzId="consumer"
                    nzPlaceHolder="Select Participant" nzShowSearch
                    [ngClass]="{ 'error-border': isFieldEmpty('consumer') }">
                    @for(opt of consumers; track $index){
                    <nz-option [nzLabel]="opt.consumerFullName" [nzValue]="opt.consumerId"></nz-option>
                    }
                </nz-select>

                @if(!consumers || consumers.length == 0){
                <span class="pl-1 error-message">You don't have any active participants.</span>
                }
            </nz-form-control>
        </nz-row>
    </nz-form-item>

    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumer" class="ppl-form-label">
                Service Code
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
                    nzAllowClear (ngModelChange)="updateTimesheetUnits()"
                    [ngClass]="{ 'error-border': isFieldEmpty('service') }">
                    <nz-option *ngFor="let opt of serviceCodesTO" [nzLabel]="opt.serviceCodeDetail"
                        [nzValue]="opt.serviceCodeDetailId"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-row>
    </nz-form-item>

    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="serviceDate" class="ppl-form-label">
                Service Date
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <p-datepicker formControlName="serviceDate" placeholder="Select Service Date"
                    [ngClass]="{ 'error-border': isFieldEmpty('serviceDate') }">
                </p-datepicker>
            </nz-form-control>
        </nz-row>
    </nz-form-item>


    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="serviceDate" class="ppl-form-label">
                Time In
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <p-datepicker formControlName="serviceTimeIn" [timeOnly]="true" [hourFormat]="'12'" appendTo="body" [panelStyleClass]="'custom-calendar-panel'" [dataType]="'date'"
                    placeholder="HH:MM AM/PM" inputStyleClass="p-inputtext-sm" (onShow)="onTimePickerShow('serviceTimeIn')"
                    [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn') || isBilledUnitsNegative() }">
                </p-datepicker>
                <div *ngIf="fieldErrors?.['timeInEqualTimeOut']">
                    <p class="error-message">{{timeInTimeOutEqualMessage}}</p>
                </div>
            </nz-form-control>
        </nz-row>
    </nz-form-item>


    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="serviceTimeOut" class="ppl-form-label">
                Time Out
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <p-datepicker formControlName="serviceTimeOut" [timeOnly]="true" [hourFormat]="'12'" appendTo="body" [panelStyleClass]="'custom-calendar-panel'" [dataType]="'date'"
                    placeholder="HH:MM AM/PM" inputStyleClass="p-inputtext-sm" (onShow)="onTimePickerShow('serviceTimeOut')"
                    [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut') || isBilledUnitsNegative() || fieldErrors?.['timeInAfterTimeOut'] || fieldErrors?.['timeInAfterTimeOutOverNightShift'] || fieldErrors?.['timeInEqualTimeOut']}">
                </p-datepicker>
                <div
                    *ngIf="applySickLeaveForm.get('serviceTimeIn')?.value && applySickLeaveForm.get('serviceTimeOut')?.value && fieldErrors?.['timeInAfterTimeOut']">
                    <p class="error-message">{{timeOutLessThanTimeInMessage}}</p>
                </div>
                <div *ngIf="fieldErrors?.['timeInAfterTimeOutOverNightShift']">
                    <p class="error-message">{{timeOutOverNightShiftMessage}}</p>
                </div>
            </nz-form-control>
        </nz-row>
    </nz-form-item>


    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="totalTime" class="ppl-form-label">
                Total Time
                <span class="required-asterisk">*</span>
            </nz-form-label>
            <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                <span style="font-size: 14px; font-weight: 500;">{{ applySickLeaveForm.get('totalTime')?.value || '--' }}</span>
            </nz-form-control>
        </nz-row>
    </nz-form-item>

    <div class="custom-row">
        <label nz-checkbox formControlName="isAgreed" [ngClass]="{'error-class': isConsentRequired && !isAgreed}">
            By signing below, I certify that I have provided the services to the participant during the times described
            on this
            timesheet.
        </label>
    </div>
    @if(saveTimeOffErrorMessage) {
        <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
            <span>{{saveTimeOffErrorMessage}}</span>
        </div>
    }
    <div class="custom-row" style="width: 100%;">
        <ppl-button (click)="saveTimeOff()" [styleString]="'margin-right: 8px;'" label="Submit"
            icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
            [disabled]="!isFormValid()"></ppl-button>
    </div>
</form>